//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import moment from "moment";
import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  CancelToken
} from "axios";
export class AuthorizedApiBase {
  private readonly config: Config;

  protected constructor(config: Config) {
    this.config = config;
  }

  protected transformOptions = (
    options: AxiosRequestConfig
  ): Promise<AxiosRequestConfig> => {
    return Promise.resolve(this.config.transformHeaders(options));
  };

  protected transformResult(
    url: string,
    response: AxiosResponse,
    processor: (response: AxiosResponse) => Promise<any>
  ): Promise<any> {
    return this.config.transformResult(url, response, processor);
  }
}

export class IdentityClient_V2 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    login(dto: AuthenticationRequestDTO, signal?: AbortSignal): Promise<AuthenticationResultDTO> {
        let url_ = this.baseUrl + "/Identity/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLogin(_response));
        });
    }

    protected processLogin(response: AxiosResponse): Promise<AuthenticationResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticationResultDTO.fromJS(resultData200);
            return Promise.resolve<AuthenticationResultDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = AuthenticationResultDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = AuthenticationResultDTO.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticationResultDTO>(null as any);
    }

    refreshToken(dto: RefreshTokenDTO, signal?: AbortSignal): Promise<AuthenticationResultDTO> {
        let url_ = this.baseUrl + "/Identity/RefreshToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRefreshToken(_response));
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<AuthenticationResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticationResultDTO.fromJS(resultData200);
            return Promise.resolve<AuthenticationResultDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = AuthenticationResultDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticationResultDTO>(null as any);
    }

    revokeToken(dto: RefreshTokenDTO, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Identity/RevokeToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRevokeToken(_response));
        });
    }

    protected processRevokeToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    forgotPassword(forgotPasswordDTO: ForgotPasswordDTO, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Identity/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(forgotPasswordDTO);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processForgotPassword(_response));
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resetPassword(resetPasswordDto: ResetPasswordDTO, signal?: AbortSignal): Promise<ResetPasswordDTO> {
        let url_ = this.baseUrl + "/Identity/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resetPasswordDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processResetPassword(_response));
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<ResetPasswordDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetPasswordDTO.fromJS(resultData200);
            return Promise.resolve<ResetPasswordDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ResetPasswordDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetPasswordDTO>(null as any);
    }

    register(dto: RegisterDTO, signal?: AbortSignal): Promise<RegisterDTO> {
        let url_ = this.baseUrl + "/Identity/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegister(_response));
        });
    }

    protected processRegister(response: AxiosResponse): Promise<RegisterDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterDTO.fromJS(resultData200);
            return Promise.resolve<RegisterDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = RegisterDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterDTO>(null as any);
    }

    confirmEmail(dto: EmailConfirmationDTO, signal?: AbortSignal): Promise<EmailConfirmationDTO> {
        let url_ = this.baseUrl + "/Identity/ConfirmEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConfirmEmail(_response));
        });
    }

    protected processConfirmEmail(response: AxiosResponse): Promise<EmailConfirmationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailConfirmationDTO.fromJS(resultData200);
            return Promise.resolve<EmailConfirmationDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = EmailConfirmationDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailConfirmationDTO>(null as any);
    }

    acceptTermsAndConditions(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Identity/AcceptTermsAndConditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAcceptTermsAndConditions(_response));
        });
    }

    protected processAcceptTermsAndConditions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    changePassword(dto: ChangePasswordDTO, signal?: AbortSignal): Promise<ChangePasswordDTO> {
        let url_ = this.baseUrl + "/Identity/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processChangePassword(_response));
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<ChangePasswordDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangePasswordDTO.fromJS(resultData200);
            return Promise.resolve<ChangePasswordDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ChangePasswordDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangePasswordDTO>(null as any);
    }

    sendConfirmEmail(userId?: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Identity/SendConfirmEmail?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendConfirmEmail(_response));
        });
    }

    protected processSendConfirmEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getProfile(userId: string, signal?: AbortSignal): Promise<ProfileDTO> {
        let url_ = this.baseUrl + "/Identity/UserProfile/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProfile(_response));
        });
    }

    protected processGetProfile(response: AxiosResponse): Promise<ProfileDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfileDTO.fromJS(resultData200);
            return Promise.resolve<ProfileDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileDTO>(null as any);
    }

    updateProfile(userId: string, userProfile: ProfileDTO, signal?: AbortSignal): Promise<ProfileDTO> {
        let url_ = this.baseUrl + "/Identity/UserProfile/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userProfile);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateProfile(_response));
        });
    }

    protected processUpdateProfile(response: AxiosResponse): Promise<ProfileDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfileDTO.fromJS(resultData200);
            return Promise.resolve<ProfileDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProfileDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileDTO>(null as any);
    }

    getUsers(search?: string | null | undefined, signal?: AbortSignal): Promise<UserDTO[]> {
        let url_ = this.baseUrl + "/Identity/Users?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUsers(_response));
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<UserDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDTO[]>(null as any);
    }

    getUserVins(user?: string | undefined, signal?: AbortSignal): Promise<VehicleDTO[]> {
        let url_ = this.baseUrl + "/Identity/Vins?";
        if (user === null)
            throw new Error("The parameter 'user' cannot be null.");
        else if (user !== undefined)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserVins(_response));
        });
    }

    protected processGetUserVins(response: AxiosResponse): Promise<VehicleDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<VehicleDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleDTO[]>(null as any);
    }

    updateUser(userId: string, user: UpdateUserDTO, signal?: AbortSignal): Promise<UpdateUserDTO> {
        let url_ = this.baseUrl + "/Identity/User/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateUser(_response));
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<UpdateUserDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateUserDTO.fromJS(resultData200);
            return Promise.resolve<UpdateUserDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = UpdateUserDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateUserDTO>(null as any);
    }

    toggleLockout(userId?: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Identity/ToggleLockout?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processToggleLockout(_response));
        });
    }

    protected processToggleLockout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getRoles(signal?: AbortSignal): Promise<RoleDTO[]> {
        let url_ = this.baseUrl + "/Identity/Roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetRoles(_response));
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<RoleDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RoleDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDTO[]>(null as any);
    }

    createRole(role: RoleDTO, signal?: AbortSignal): Promise<RoleDTO> {
        let url_ = this.baseUrl + "/Identity/Role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(role);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateRole(_response));
        });
    }

    protected processCreateRole(response: AxiosResponse): Promise<RoleDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDTO.fromJS(resultData200);
            return Promise.resolve<RoleDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = RoleDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDTO>(null as any);
    }

    updateRole(roleId: string, role: RoleDTO, signal?: AbortSignal): Promise<RoleDTO> {
        let url_ = this.baseUrl + "/Identity/Role/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(role);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateRole(_response));
        });
    }

    protected processUpdateRole(response: AxiosResponse): Promise<RoleDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDTO.fromJS(resultData200);
            return Promise.resolve<RoleDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = RoleDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDTO>(null as any);
    }

    deleteRole(roleId: string, signal?: AbortSignal): Promise<RoleDTO> {
        let url_ = this.baseUrl + "/Identity/Role/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteRole(_response));
        });
    }

    protected processDeleteRole(response: AxiosResponse): Promise<RoleDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDTO.fromJS(resultData200);
            return Promise.resolve<RoleDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = RoleDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDTO>(null as any);
    }
}

export class LookupClient_V2 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    spiffTypes(signal?: AbortSignal): Promise<SpiffTypeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/SpiffTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSpiffTypes(_response));
        });
    }

    protected processSpiffTypes(response: AxiosResponse): Promise<SpiffTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpiffTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SpiffTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpiffTypeDTO[]>(null as any);
    }

    brands(signal?: AbortSignal): Promise<BrandDTO[]> {
        let url_ = this.baseUrl + "/Lookup/Brands";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processBrands(_response));
        });
    }

    protected processBrands(response: AxiosResponse): Promise<BrandDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BrandDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BrandDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BrandDTO[]>(null as any);
    }

    catalogBrands(signal?: AbortSignal): Promise<CatalogBrandDTO[]> {
        let url_ = this.baseUrl + "/Lookup/CatalogBrands";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCatalogBrands(_response));
        });
    }

    protected processCatalogBrands(response: AxiosResponse): Promise<CatalogBrandDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CatalogBrandDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CatalogBrandDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogBrandDTO[]>(null as any);
    }

    deliveryModes(signal?: AbortSignal): Promise<DeliveryModeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/DeliveryModes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeliveryModes(_response));
        });
    }

    protected processDeliveryModes(response: AxiosResponse): Promise<DeliveryModeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliveryModeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeliveryModeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryModeDTO[]>(null as any);
    }

    catalogYearsByBrand(brandId?: string | null | undefined, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/Lookup/CatalogYearsByBrand?";
        if (brandId !== undefined && brandId !== null)
            url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCatalogYearsByBrand(_response));
        });
    }

    protected processCatalogYearsByBrand(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    checklistTypes(signal?: AbortSignal): Promise<ChecklistTypeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/ChecklistTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processChecklistTypes(_response));
        });
    }

    protected processChecklistTypes(response: AxiosResponse): Promise<ChecklistTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChecklistTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ChecklistTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChecklistTypeDTO[]>(null as any);
    }

    companyType(signal?: AbortSignal): Promise<CompanyTypeDTO> {
        let url_ = this.baseUrl + "/Lookup/CompanyType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCompanyType(_response));
        });
    }

    protected processCompanyType(response: AxiosResponse): Promise<CompanyTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompanyTypeDTO.fromJS(resultData200);
            return Promise.resolve<CompanyTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompanyTypeDTO>(null as any);
    }

    countries(signal?: AbortSignal): Promise<CountryLookupDTO[]> {
        let url_ = this.baseUrl + "/Lookup/Countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCountries(_response));
        });
    }

    protected processCountries(response: AxiosResponse): Promise<CountryLookupDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryLookupDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CountryLookupDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountryLookupDTO[]>(null as any);
    }

    documentTypes(signal?: AbortSignal): Promise<DocumentTypeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/DocumentTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDocumentTypes(_response));
        });
    }

    protected processDocumentTypes(response: AxiosResponse): Promise<DocumentTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentTypeDTO[]>(null as any);
    }

    states(signal?: AbortSignal): Promise<StateLookupDTO[]> {
        let url_ = this.baseUrl + "/Lookup/States";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processStates(_response));
        });
    }

    protected processStates(response: AxiosResponse): Promise<StateLookupDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StateLookupDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StateLookupDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StateLookupDTO[]>(null as any);
    }

    settings(signal?: AbortSignal): Promise<SettingDTO> {
        let url_ = this.baseUrl + "/Lookup/Settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSettings(_response));
        });
    }

    protected processSettings(response: AxiosResponse): Promise<SettingDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SettingDTO.fromJS(resultData200);
            return Promise.resolve<SettingDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettingDTO>(null as any);
    }

    dealerSettings(signal?: AbortSignal): Promise<DealerSettingDTO> {
        let url_ = this.baseUrl + "/Lookup/DealerSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDealerSettings(_response));
        });
    }

    protected processDealerSettings(response: AxiosResponse): Promise<DealerSettingDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DealerSettingDTO.fromJS(resultData200);
            return Promise.resolve<DealerSettingDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DealerSettingDTO>(null as any);
    }

    termsAndConditions(companyType?: CompanyTypes | undefined, signal?: AbortSignal): Promise<TermsAndConditionDTO> {
        let url_ = this.baseUrl + "/Lookup/TermsAndConditions?";
        if (companyType === null)
            throw new Error("The parameter 'companyType' cannot be null.");
        else if (companyType !== undefined)
            url_ += "companyType=" + encodeURIComponent("" + companyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTermsAndConditions(_response));
        });
    }

    protected processTermsAndConditions(response: AxiosResponse): Promise<TermsAndConditionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TermsAndConditionDTO.fromJS(resultData200);
            return Promise.resolve<TermsAndConditionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TermsAndConditionDTO>(null as any);
    }

    roles(signal?: AbortSignal): Promise<LookupTypeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/Roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRoles(_response));
        });
    }

    protected processRoles(response: AxiosResponse): Promise<LookupTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LookupTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LookupTypeDTO[]>(null as any);
    }

    dealerUserRoles(dealerAccountUid?: string | null | undefined, signal?: AbortSignal): Promise<LookupTypeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/DealerUserRoles?";
        if (dealerAccountUid !== undefined && dealerAccountUid !== null)
            url_ += "dealerAccountUid=" + encodeURIComponent("" + dealerAccountUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDealerUserRoles(_response));
        });
    }

    protected processDealerUserRoles(response: AxiosResponse): Promise<LookupTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LookupTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LookupTypeDTO[]>(null as any);
    }

    dealerAdminRoles(signal?: AbortSignal): Promise<LookupTypeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/DealerAdminRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDealerAdminRoles(_response));
        });
    }

    protected processDealerAdminRoles(response: AxiosResponse): Promise<LookupTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LookupTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LookupTypeDTO[]>(null as any);
    }

    permissions(signal?: AbortSignal): Promise<LookupTypeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/Permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPermissions(_response));
        });
    }

    protected processPermissions(response: AxiosResponse): Promise<LookupTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LookupTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LookupTypeDTO[]>(null as any);
    }

    postalCodeInfo(countryCode?: string | null | undefined, postalCode?: string | null | undefined, signal?: AbortSignal): Promise<PostalCodeInfoDTO[]> {
        let url_ = this.baseUrl + "/Lookup/PostalCodeInfo?";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (postalCode !== undefined && postalCode !== null)
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPostalCodeInfo(_response));
        });
    }

    protected processPostalCodeInfo(response: AxiosResponse): Promise<PostalCodeInfoDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PostalCodeInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PostalCodeInfoDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostalCodeInfoDTO[]>(null as any);
    }

    dynamicsCountries(signal?: AbortSignal): Promise<DynamicsCountryDTO[]> {
        let url_ = this.baseUrl + "/Lookup/DynamicsCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDynamicsCountries(_response));
        });
    }

    protected processDynamicsCountries(response: AxiosResponse): Promise<DynamicsCountryDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DynamicsCountryDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DynamicsCountryDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DynamicsCountryDTO[]>(null as any);
    }

    claimStatusTypes(signal?: AbortSignal): Promise<ClaimStatusTypeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/ClaimStatusTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processClaimStatusTypes(_response));
        });
    }

    protected processClaimStatusTypes(response: AxiosResponse): Promise<ClaimStatusTypeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaimStatusTypeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ClaimStatusTypeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClaimStatusTypeDTO[]>(null as any);
    }

    warrantyClassCodes(signal?: AbortSignal): Promise<WarrantyClassCodeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/WarrantyClassCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWarrantyClassCodes(_response));
        });
    }

    protected processWarrantyClassCodes(response: AxiosResponse): Promise<WarrantyClassCodeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarrantyClassCodeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WarrantyClassCodeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WarrantyClassCodeDTO[]>(null as any);
    }

    warrantyRemedyCodes(signal?: AbortSignal): Promise<WarrantyRemedyCodeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/WarrantyRemedyCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWarrantyRemedyCodes(_response));
        });
    }

    protected processWarrantyRemedyCodes(response: AxiosResponse): Promise<WarrantyRemedyCodeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarrantyRemedyCodeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WarrantyRemedyCodeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WarrantyRemedyCodeDTO[]>(null as any);
    }

    warrantyFailureCodes(signal?: AbortSignal): Promise<WarrantyFailureCodeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/WarrantyFailureCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWarrantyFailureCodes(_response));
        });
    }

    protected processWarrantyFailureCodes(response: AxiosResponse): Promise<WarrantyFailureCodeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarrantyFailureCodeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WarrantyFailureCodeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WarrantyFailureCodeDTO[]>(null as any);
    }

    warrantyMiscChargeCodes(signal?: AbortSignal): Promise<WarrantyMiscChargeCodeDTO[]> {
        let url_ = this.baseUrl + "/Lookup/WarrantyMiscChargeCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processWarrantyMiscChargeCodes(_response));
        });
    }

    protected processWarrantyMiscChargeCodes(response: AxiosResponse): Promise<WarrantyMiscChargeCodeDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarrantyMiscChargeCodeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WarrantyMiscChargeCodeDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WarrantyMiscChargeCodeDTO[]>(null as any);
    }

    exportWarrantyClassCodes(signal?: AbortSignal): Promise<ExportDTO> {
        let url_ = this.baseUrl + "/Lookup/ExportWarrantyClassCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportWarrantyClassCodes(_response));
        });
    }

    protected processExportWarrantyClassCodes(response: AxiosResponse): Promise<ExportDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportDTO.fromJS(resultData200);
            return Promise.resolve<ExportDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportDTO>(null as any);
    }
}

export class NotificationClient_V2 extends AuthorizedApiBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    registerToken(dto: NotificationRegistrationDTO, signal?: AbortSignal): Promise<NotificationRegistrationDTO> {
        let url_ = this.baseUrl + "/Notification/RegisterToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegisterToken(_response));
        });
    }

    protected processRegisterToken(response: AxiosResponse): Promise<NotificationRegistrationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NotificationRegistrationDTO.fromJS(resultData200);
            return Promise.resolve<NotificationRegistrationDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = NotificationRegistrationDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationRegistrationDTO>(null as any);
    }

    send(dto: NotificationDTO, signal?: AbortSignal): Promise<NotificationDTO> {
        let url_ = this.baseUrl + "/Notification/Send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSend(_response));
        });
    }

    protected processSend(response: AxiosResponse): Promise<NotificationDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NotificationDTO.fromJS(resultData200);
            return Promise.resolve<NotificationDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = NotificationDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationDTO>(null as any);
    }

    userNotifications(signal?: AbortSignal): Promise<UserNotificationDTO[]> {
        let url_ = this.baseUrl + "/Notification/UserNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserNotifications(_response));
        });
    }

    protected processUserNotifications(response: AxiosResponse): Promise<UserNotificationDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserNotificationDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserNotificationDTO[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(UserNotificationDTO.fromJS(item));
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserNotificationDTO[]>(null as any);
    }

    notificationRead(userNotifcationId?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Notification/NotificationRead?";
        if (userNotifcationId === null)
            throw new Error("The parameter 'userNotifcationId' cannot be null.");
        else if (userNotifcationId !== undefined)
            url_ += "userNotifcationId=" + encodeURIComponent("" + userNotifcationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processNotificationRead(_response));
        });
    }

    protected processNotificationRead(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteNotification(userNotifcationId?: string | undefined, signal?: AbortSignal): Promise<ApiResultDTO> {
        let url_ = this.baseUrl + "/Notification/DeleteNotification?";
        if (userNotifcationId === null)
            throw new Error("The parameter 'userNotifcationId' cannot be null.");
        else if (userNotifcationId !== undefined)
            url_ += "userNotifcationId=" + encodeURIComponent("" + userNotifcationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteNotification(_response));
        });
    }

    protected processDeleteNotification(response: AxiosResponse): Promise<ApiResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResultDTO.fromJS(resultData200);
            return Promise.resolve<ApiResultDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ApiResultDTO.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResultDTO>(null as any);
    }
}

export class ValidationBaseDTO implements IValidationBaseDTO {
    isValid?: boolean;
    errors?: string[] | null;

    constructor(data?: IValidationBaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : <any>null;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = <any>null;
            }
        }
    }

    static fromJS(data: any): ValidationBaseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationBaseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid !== undefined ? this.isValid : <any>null;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }

    clone(): ValidationBaseDTO {
        const json = this.toJSON();
        let result = new ValidationBaseDTO();
        result.init(json);
        return result;
    }
}

export interface IValidationBaseDTO {
    isValid?: boolean;
    errors?: string[] | null;
}

export class AuthenticationResultDTO extends ValidationBaseDTO implements IAuthenticationResultDTO {
    succeeded?: boolean;
    isLockedOut?: boolean;
    accessToken?: string | null;
    refreshToken?: string | null;
    claims?: Claim[] | null;

    constructor(data?: IAuthenticationResultDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.succeeded = _data["succeeded"] !== undefined ? _data["succeeded"] : <any>null;
            this.isLockedOut = _data["isLockedOut"] !== undefined ? _data["isLockedOut"] : <any>null;
            this.accessToken = _data["accessToken"] !== undefined ? _data["accessToken"] : <any>null;
            this.refreshToken = _data["refreshToken"] !== undefined ? _data["refreshToken"] : <any>null;
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(Claim.fromJS(item));
            }
            else {
                this.claims = <any>null;
            }
        }
    }

    static fromJS(data: any): AuthenticationResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded !== undefined ? this.succeeded : <any>null;
        data["isLockedOut"] = this.isLockedOut !== undefined ? this.isLockedOut : <any>null;
        data["accessToken"] = this.accessToken !== undefined ? this.accessToken : <any>null;
        data["refreshToken"] = this.refreshToken !== undefined ? this.refreshToken : <any>null;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): AuthenticationResultDTO {
        const json = this.toJSON();
        let result = new AuthenticationResultDTO();
        result.init(json);
        return result;
    }
}

export interface IAuthenticationResultDTO extends IValidationBaseDTO {
    succeeded?: boolean;
    isLockedOut?: boolean;
    accessToken?: string | null;
    refreshToken?: string | null;
    claims?: Claim[] | null;
}

export class Claim implements IClaim {
    issuer?: string;
    originalIssuer?: string;
    properties?: { [key: string]: string; };
    subject?: ClaimsIdentity | null;
    type?: string;
    value?: string;
    valueType?: string;

    constructor(data?: IClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issuer = _data["issuer"] !== undefined ? _data["issuer"] : <any>null;
            this.originalIssuer = _data["originalIssuer"] !== undefined ? _data["originalIssuer"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
            this.subject = _data["subject"] ? ClaimsIdentity.fromJS(_data["subject"]) : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.valueType = _data["valueType"] !== undefined ? _data["valueType"] : <any>null;
        }
    }

    static fromJS(data: any): Claim {
        data = typeof data === 'object' ? data : {};
        let result = new Claim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuer"] = this.issuer !== undefined ? this.issuer : <any>null;
        data["originalIssuer"] = this.originalIssuer !== undefined ? this.originalIssuer : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        data["subject"] = this.subject ? this.subject.toJSON() : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["valueType"] = this.valueType !== undefined ? this.valueType : <any>null;
        return data;
    }

    clone(): Claim {
        const json = this.toJSON();
        let result = new Claim();
        result.init(json);
        return result;
    }
}

export interface IClaim {
    issuer?: string;
    originalIssuer?: string;
    properties?: { [key: string]: string; };
    subject?: ClaimsIdentity | null;
    type?: string;
    value?: string;
    valueType?: string;
}

export class ClaimsIdentity implements IClaimsIdentity {
    authenticationType?: string | null;
    isAuthenticated?: boolean;
    actor?: ClaimsIdentity | null;
    bootstrapContext?: any | null;
    claims?: Claim[];
    label?: string | null;
    name?: string | null;
    nameClaimType?: string;
    roleClaimType?: string;

    constructor(data?: IClaimsIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authenticationType = _data["authenticationType"] !== undefined ? _data["authenticationType"] : <any>null;
            this.isAuthenticated = _data["isAuthenticated"] !== undefined ? _data["isAuthenticated"] : <any>null;
            this.actor = _data["actor"] ? ClaimsIdentity.fromJS(_data["actor"]) : <any>null;
            this.bootstrapContext = _data["bootstrapContext"] !== undefined ? _data["bootstrapContext"] : <any>null;
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(Claim.fromJS(item));
            }
            else {
                this.claims = <any>null;
            }
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.nameClaimType = _data["nameClaimType"] !== undefined ? _data["nameClaimType"] : <any>null;
            this.roleClaimType = _data["roleClaimType"] !== undefined ? _data["roleClaimType"] : <any>null;
        }
    }

    static fromJS(data: any): ClaimsIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authenticationType"] = this.authenticationType !== undefined ? this.authenticationType : <any>null;
        data["isAuthenticated"] = this.isAuthenticated !== undefined ? this.isAuthenticated : <any>null;
        data["actor"] = this.actor ? this.actor.toJSON() : <any>null;
        data["bootstrapContext"] = this.bootstrapContext !== undefined ? this.bootstrapContext : <any>null;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["nameClaimType"] = this.nameClaimType !== undefined ? this.nameClaimType : <any>null;
        data["roleClaimType"] = this.roleClaimType !== undefined ? this.roleClaimType : <any>null;
        return data;
    }

    clone(): ClaimsIdentity {
        const json = this.toJSON();
        let result = new ClaimsIdentity();
        result.init(json);
        return result;
    }
}

export interface IClaimsIdentity {
    authenticationType?: string | null;
    isAuthenticated?: boolean;
    actor?: ClaimsIdentity | null;
    bootstrapContext?: any | null;
    claims?: Claim[];
    label?: string | null;
    name?: string | null;
    nameClaimType?: string;
    roleClaimType?: string;
}

export class AuthenticationRequestDTO implements IAuthenticationRequestDTO {
    userName!: string;
    password!: string;
    companyType?: CompanyTypes;

    constructor(data?: IAuthenticationRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
        }
    }

    static fromJS(data: any): AuthenticationRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        return data;
    }

    clone(): AuthenticationRequestDTO {
        const json = this.toJSON();
        let result = new AuthenticationRequestDTO();
        result.init(json);
        return result;
    }
}

export interface IAuthenticationRequestDTO {
    userName: string;
    password: string;
    companyType?: CompanyTypes;
}

export enum CompanyTypes {
    Unknown = 0,
    HRV = 1,
    CRV = 2,
    DRV = 3,
    Dealer = 4,
}

export class RefreshTokenDTO implements IRefreshTokenDTO {
    refreshToken!: string;
    expiredAccessToken?: string | null;

    constructor(data?: IRefreshTokenDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"] !== undefined ? _data["refreshToken"] : <any>null;
            this.expiredAccessToken = _data["expiredAccessToken"] !== undefined ? _data["expiredAccessToken"] : <any>null;
        }
    }

    static fromJS(data: any): RefreshTokenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken !== undefined ? this.refreshToken : <any>null;
        data["expiredAccessToken"] = this.expiredAccessToken !== undefined ? this.expiredAccessToken : <any>null;
        return data;
    }

    clone(): RefreshTokenDTO {
        const json = this.toJSON();
        let result = new RefreshTokenDTO();
        result.init(json);
        return result;
    }
}

export interface IRefreshTokenDTO {
    refreshToken: string;
    expiredAccessToken?: string | null;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        return data;
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export class ForgotPasswordDTO extends ValidationBaseDTO implements IForgotPasswordDTO {
    email!: string;
    companyType!: CompanyTypes;

    constructor(data?: IForgotPasswordDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
        }
    }

    static fromJS(data: any): ForgotPasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ForgotPasswordDTO {
        const json = this.toJSON();
        let result = new ForgotPasswordDTO();
        result.init(json);
        return result;
    }
}

export interface IForgotPasswordDTO extends IValidationBaseDTO {
    email: string;
    companyType: CompanyTypes;
}

export class ResetPasswordDTO extends ValidationBaseDTO implements IResetPasswordDTO {
    token!: string;
    email!: string;
    password!: string;
    confirmPassword!: string;

    constructor(data?: IResetPasswordDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.confirmPassword = _data["confirmPassword"] !== undefined ? _data["confirmPassword"] : <any>null;
        }
    }

    static fromJS(data: any): ResetPasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token !== undefined ? this.token : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["confirmPassword"] = this.confirmPassword !== undefined ? this.confirmPassword : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ResetPasswordDTO {
        const json = this.toJSON();
        let result = new ResetPasswordDTO();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDTO extends IValidationBaseDTO {
    token: string;
    email: string;
    password: string;
    confirmPassword: string;
}

export class RegisterDTO extends ValidationBaseDTO implements IRegisterDTO {
    userId?: string | null;
    firstName!: string;
    lastName!: string;
    email!: string;
    phoneNumber!: string;
    streetAddress!: string;
    city!: string;
    stateId!: number;
    zipCode!: string;
    countryId!: number;
    password!: string;
    confirmPassword!: string;
    invitationCode?: string | null;
    invitationId?: string | null;
    companyType?: CompanyTypes;

    constructor(data?: IRegisterDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.streetAddress = _data["streetAddress"] !== undefined ? _data["streetAddress"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.stateId = _data["stateId"] !== undefined ? _data["stateId"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.confirmPassword = _data["confirmPassword"] !== undefined ? _data["confirmPassword"] : <any>null;
            this.invitationCode = _data["invitationCode"] !== undefined ? _data["invitationCode"] : <any>null;
            this.invitationId = _data["invitationId"] !== undefined ? _data["invitationId"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["streetAddress"] = this.streetAddress !== undefined ? this.streetAddress : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["stateId"] = this.stateId !== undefined ? this.stateId : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["confirmPassword"] = this.confirmPassword !== undefined ? this.confirmPassword : <any>null;
        data["invitationCode"] = this.invitationCode !== undefined ? this.invitationCode : <any>null;
        data["invitationId"] = this.invitationId !== undefined ? this.invitationId : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): RegisterDTO {
        const json = this.toJSON();
        let result = new RegisterDTO();
        result.init(json);
        return result;
    }
}

export interface IRegisterDTO extends IValidationBaseDTO {
    userId?: string | null;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    streetAddress: string;
    city: string;
    stateId: number;
    zipCode: string;
    countryId: number;
    password: string;
    confirmPassword: string;
    invitationCode?: string | null;
    invitationId?: string | null;
    companyType?: CompanyTypes;
}

export class EmailConfirmationDTO extends ValidationBaseDTO implements IEmailConfirmationDTO {
    id?: string | null;
    code?: string | null;
    companyType?: number;

    constructor(data?: IEmailConfirmationDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
        }
    }

    static fromJS(data: any): EmailConfirmationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmailConfirmationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): EmailConfirmationDTO {
        const json = this.toJSON();
        let result = new EmailConfirmationDTO();
        result.init(json);
        return result;
    }
}

export interface IEmailConfirmationDTO extends IValidationBaseDTO {
    id?: string | null;
    code?: string | null;
    companyType?: number;
}

export class ChangePasswordDTO extends ValidationBaseDTO implements IChangePasswordDTO {
    currentPassword!: string;
    newPassword!: string;
    confirmPassword!: string;

    constructor(data?: IChangePasswordDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.currentPassword = _data["currentPassword"] !== undefined ? _data["currentPassword"] : <any>null;
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : <any>null;
            this.confirmPassword = _data["confirmPassword"] !== undefined ? _data["confirmPassword"] : <any>null;
        }
    }

    static fromJS(data: any): ChangePasswordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword !== undefined ? this.currentPassword : <any>null;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : <any>null;
        data["confirmPassword"] = this.confirmPassword !== undefined ? this.confirmPassword : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ChangePasswordDTO {
        const json = this.toJSON();
        let result = new ChangePasswordDTO();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDTO extends IValidationBaseDTO {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
}

export class ProfileDTO extends ValidationBaseDTO implements IProfileDTO {
    userId?: string;
    firstName!: string;
    lastName!: string;
    phoneNumber!: string;
    streetAddress!: string;
    city!: string;
    stateId!: number;
    zipCode!: string;
    countryId!: number;
    allowEmailNotifications!: boolean;
    allowPushNotifications!: boolean;

    constructor(data?: IProfileDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.streetAddress = _data["streetAddress"] !== undefined ? _data["streetAddress"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.stateId = _data["stateId"] !== undefined ? _data["stateId"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
            this.allowEmailNotifications = _data["allowEmailNotifications"] !== undefined ? _data["allowEmailNotifications"] : <any>null;
            this.allowPushNotifications = _data["allowPushNotifications"] !== undefined ? _data["allowPushNotifications"] : <any>null;
        }
    }

    static fromJS(data: any): ProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["streetAddress"] = this.streetAddress !== undefined ? this.streetAddress : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["stateId"] = this.stateId !== undefined ? this.stateId : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        data["allowEmailNotifications"] = this.allowEmailNotifications !== undefined ? this.allowEmailNotifications : <any>null;
        data["allowPushNotifications"] = this.allowPushNotifications !== undefined ? this.allowPushNotifications : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ProfileDTO {
        const json = this.toJSON();
        let result = new ProfileDTO();
        result.init(json);
        return result;
    }
}

export interface IProfileDTO extends IValidationBaseDTO {
    userId?: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    streetAddress: string;
    city: string;
    stateId: number;
    zipCode: string;
    countryId: number;
    allowEmailNotifications: boolean;
    allowPushNotifications: boolean;
}

export class UserDTO extends ValidationBaseDTO implements IUserDTO {
    userId?: string;
    userName?: string | null;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    currentTitle?: string | null;
    zipCode?: string | null;
    countryCode?: string | null;
    phoneNumber?: string | null;
    lockoutEnd?: moment.Moment | null;
    emailConfirmed?: boolean;
    roles?: string[] | null;
    lastLoginDate?: moment.Moment | null;
    createdDate?: moment.Moment;

    constructor(data?: IUserDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.currentTitle = _data["currentTitle"] !== undefined ? _data["currentTitle"] : <any>null;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : <any>null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.lockoutEnd = _data["lockoutEnd"] ? moment(_data["lockoutEnd"].toString()) : <any>null;
            this.emailConfirmed = _data["emailConfirmed"] !== undefined ? _data["emailConfirmed"] : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = <any>null;
            }
            this.lastLoginDate = _data["lastLoginDate"] ? moment(_data["lastLoginDate"].toString()) : <any>null;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["currentTitle"] = this.currentTitle !== undefined ? this.currentTitle : <any>null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : <any>null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>null;
        data["emailConfirmed"] = this.emailConfirmed !== undefined ? this.emailConfirmed : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["lastLoginDate"] = this.lastLoginDate ? this.lastLoginDate.toISOString() : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): UserDTO {
        const json = this.toJSON();
        let result = new UserDTO();
        result.init(json);
        return result;
    }
}

export interface IUserDTO extends IValidationBaseDTO {
    userId?: string;
    userName?: string | null;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    currentTitle?: string | null;
    zipCode?: string | null;
    countryCode?: string | null;
    phoneNumber?: string | null;
    lockoutEnd?: moment.Moment | null;
    emailConfirmed?: boolean;
    roles?: string[] | null;
    lastLoginDate?: moment.Moment | null;
    createdDate?: moment.Moment;
}

export class VehicleDTO implements IVehicleDTO {
    vehicleId?: number;
    vehicleUid?: string;
    vin?: string | null;
    name?: string | null;
    make?: string | null;
    model?: string | null;
    year?: number;
    brandName?: string | null;

    constructor(data?: IVehicleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["vehicleId"] !== undefined ? _data["vehicleId"] : <any>null;
            this.vehicleUid = _data["vehicleUid"] !== undefined ? _data["vehicleUid"] : <any>null;
            this.vin = _data["vin"] !== undefined ? _data["vin"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.make = _data["make"] !== undefined ? _data["make"] : <any>null;
            this.model = _data["model"] !== undefined ? _data["model"] : <any>null;
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            this.brandName = _data["brandName"] !== undefined ? _data["brandName"] : <any>null;
        }
    }

    static fromJS(data: any): VehicleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleId"] = this.vehicleId !== undefined ? this.vehicleId : <any>null;
        data["vehicleUid"] = this.vehicleUid !== undefined ? this.vehicleUid : <any>null;
        data["vin"] = this.vin !== undefined ? this.vin : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["make"] = this.make !== undefined ? this.make : <any>null;
        data["model"] = this.model !== undefined ? this.model : <any>null;
        data["year"] = this.year !== undefined ? this.year : <any>null;
        data["brandName"] = this.brandName !== undefined ? this.brandName : <any>null;
        return data;
    }

    clone(): VehicleDTO {
        const json = this.toJSON();
        let result = new VehicleDTO();
        result.init(json);
        return result;
    }
}

export interface IVehicleDTO {
    vehicleId?: number;
    vehicleUid?: string;
    vin?: string | null;
    name?: string | null;
    make?: string | null;
    model?: string | null;
    year?: number;
    brandName?: string | null;
}

export class UpdateUserDTO extends ValidationBaseDTO implements IUpdateUserDTO {
    userId?: string;
    firstName!: string;
    lastName!: string;
    roles?: string[] | null;

    constructor(data?: IUpdateUserDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): UpdateUserDTO {
        const json = this.toJSON();
        let result = new UpdateUserDTO();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserDTO extends IValidationBaseDTO {
    userId?: string;
    firstName: string;
    lastName: string;
    roles?: string[] | null;
}

export class RoleDTO extends ValidationBaseDTO implements IRoleDTO {
    id?: string | null;
    name!: string;
    isSystemRole?: boolean;
    permissions?: PermissionDTO[] | null;

    constructor(data?: IRoleDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isSystemRole = _data["isSystemRole"] !== undefined ? _data["isSystemRole"] : <any>null;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionDTO.fromJS(item));
            }
            else {
                this.permissions = <any>null;
            }
        }
    }

    static fromJS(data: any): RoleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isSystemRole"] = this.isSystemRole !== undefined ? this.isSystemRole : <any>null;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): RoleDTO {
        const json = this.toJSON();
        let result = new RoleDTO();
        result.init(json);
        return result;
    }
}

export interface IRoleDTO extends IValidationBaseDTO {
    id?: string | null;
    name: string;
    isSystemRole?: boolean;
    permissions?: PermissionDTO[] | null;
}

export class PermissionDTO implements IPermissionDTO {
    id?: string;
    name?: string | null;
    description?: string | null;

    constructor(data?: IPermissionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): PermissionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }

    clone(): PermissionDTO {
        const json = this.toJSON();
        let result = new PermissionDTO();
        result.init(json);
        return result;
    }
}

export interface IPermissionDTO {
    id?: string;
    name?: string | null;
    description?: string | null;
}

export class SpiffTypeDTO implements ISpiffTypeDTO {
    label?: string | null;
    value?: number;

    constructor(data?: ISpiffTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): SpiffTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpiffTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }

    clone(): SpiffTypeDTO {
        const json = this.toJSON();
        let result = new SpiffTypeDTO();
        result.init(json);
        return result;
    }
}

export interface ISpiffTypeDTO {
    label?: string | null;
    value?: number;
}

export class BrandDTO implements IBrandDTO {
    brandId?: string | null;
    name?: string | null;
    company?: string | null;
    supportEmail?: string | null;

    constructor(data?: IBrandDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brandId = _data["brandId"] !== undefined ? _data["brandId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.company = _data["company"] !== undefined ? _data["company"] : <any>null;
            this.supportEmail = _data["supportEmail"] !== undefined ? _data["supportEmail"] : <any>null;
        }
    }

    static fromJS(data: any): BrandDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BrandDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandId"] = this.brandId !== undefined ? this.brandId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["company"] = this.company !== undefined ? this.company : <any>null;
        data["supportEmail"] = this.supportEmail !== undefined ? this.supportEmail : <any>null;
        return data;
    }

    clone(): BrandDTO {
        const json = this.toJSON();
        let result = new BrandDTO();
        result.init(json);
        return result;
    }
}

export interface IBrandDTO {
    brandId?: string | null;
    name?: string | null;
    company?: string | null;
    supportEmail?: string | null;
}

export class CatalogBrandDTO extends BrandDTO implements ICatalogBrandDTO {

    constructor(data?: ICatalogBrandDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CatalogBrandDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogBrandDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): CatalogBrandDTO {
        const json = this.toJSON();
        let result = new CatalogBrandDTO();
        result.init(json);
        return result;
    }
}

export interface ICatalogBrandDTO extends IBrandDTO {
}

export class DeliveryModeDTO implements IDeliveryModeDTO {
    id?: string | null;
    description?: string | null;

    constructor(data?: IDeliveryModeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): DeliveryModeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryModeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }

    clone(): DeliveryModeDTO {
        const json = this.toJSON();
        let result = new DeliveryModeDTO();
        result.init(json);
        return result;
    }
}

export interface IDeliveryModeDTO {
    id?: string | null;
    description?: string | null;
}

export class ChecklistTypeDTO implements IChecklistTypeDTO {
    id?: number;
    name?: string | null;
    sortOrder?: number;

    constructor(data?: IChecklistTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
        }
    }

    static fromJS(data: any): ChecklistTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        return data;
    }

    clone(): ChecklistTypeDTO {
        const json = this.toJSON();
        let result = new ChecklistTypeDTO();
        result.init(json);
        return result;
    }
}

export interface IChecklistTypeDTO {
    id?: number;
    name?: string | null;
    sortOrder?: number;
}

export class CompanyTypeDTO implements ICompanyTypeDTO {
    id?: number;
    name?: string | null;
    sortOrder?: number;
    companyType?: CompanyTypes;
    companyAbbreviation?: string | null;
    webPortalBaseUrl?: string | null;
    fromEmailName?: string | null;
    fromEmailAddress?: string | null;
    appName?: string | null;
    supportEmailAddress?: string | null;
    partsEmailAddress?: string | null;
    serviceEmailAddress?: string | null;
    supportPhoneNumber?: string | null;
    logoPath?: string | null;
    companyAddress?: string | null;

    constructor(data?: ICompanyTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
            this.companyAbbreviation = _data["companyAbbreviation"] !== undefined ? _data["companyAbbreviation"] : <any>null;
            this.webPortalBaseUrl = _data["webPortalBaseUrl"] !== undefined ? _data["webPortalBaseUrl"] : <any>null;
            this.fromEmailName = _data["fromEmailName"] !== undefined ? _data["fromEmailName"] : <any>null;
            this.fromEmailAddress = _data["fromEmailAddress"] !== undefined ? _data["fromEmailAddress"] : <any>null;
            this.appName = _data["appName"] !== undefined ? _data["appName"] : <any>null;
            this.supportEmailAddress = _data["supportEmailAddress"] !== undefined ? _data["supportEmailAddress"] : <any>null;
            this.partsEmailAddress = _data["partsEmailAddress"] !== undefined ? _data["partsEmailAddress"] : <any>null;
            this.serviceEmailAddress = _data["serviceEmailAddress"] !== undefined ? _data["serviceEmailAddress"] : <any>null;
            this.supportPhoneNumber = _data["supportPhoneNumber"] !== undefined ? _data["supportPhoneNumber"] : <any>null;
            this.logoPath = _data["logoPath"] !== undefined ? _data["logoPath"] : <any>null;
            this.companyAddress = _data["companyAddress"] !== undefined ? _data["companyAddress"] : <any>null;
        }
    }

    static fromJS(data: any): CompanyTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        data["companyAbbreviation"] = this.companyAbbreviation !== undefined ? this.companyAbbreviation : <any>null;
        data["webPortalBaseUrl"] = this.webPortalBaseUrl !== undefined ? this.webPortalBaseUrl : <any>null;
        data["fromEmailName"] = this.fromEmailName !== undefined ? this.fromEmailName : <any>null;
        data["fromEmailAddress"] = this.fromEmailAddress !== undefined ? this.fromEmailAddress : <any>null;
        data["appName"] = this.appName !== undefined ? this.appName : <any>null;
        data["supportEmailAddress"] = this.supportEmailAddress !== undefined ? this.supportEmailAddress : <any>null;
        data["partsEmailAddress"] = this.partsEmailAddress !== undefined ? this.partsEmailAddress : <any>null;
        data["serviceEmailAddress"] = this.serviceEmailAddress !== undefined ? this.serviceEmailAddress : <any>null;
        data["supportPhoneNumber"] = this.supportPhoneNumber !== undefined ? this.supportPhoneNumber : <any>null;
        data["logoPath"] = this.logoPath !== undefined ? this.logoPath : <any>null;
        data["companyAddress"] = this.companyAddress !== undefined ? this.companyAddress : <any>null;
        return data;
    }

    clone(): CompanyTypeDTO {
        const json = this.toJSON();
        let result = new CompanyTypeDTO();
        result.init(json);
        return result;
    }
}

export interface ICompanyTypeDTO {
    id?: number;
    name?: string | null;
    sortOrder?: number;
    companyType?: CompanyTypes;
    companyAbbreviation?: string | null;
    webPortalBaseUrl?: string | null;
    fromEmailName?: string | null;
    fromEmailAddress?: string | null;
    appName?: string | null;
    supportEmailAddress?: string | null;
    partsEmailAddress?: string | null;
    serviceEmailAddress?: string | null;
    supportPhoneNumber?: string | null;
    logoPath?: string | null;
    companyAddress?: string | null;
}

export class LookupTypeDTO implements ILookupTypeDTO {
    id?: number;
    uid?: string | null;
    name?: string | null;
    description?: string | null;
    sortOrder?: number;

    constructor(data?: ILookupTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.uid = _data["uid"] !== undefined ? _data["uid"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
        }
    }

    static fromJS(data: any): LookupTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LookupTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["uid"] = this.uid !== undefined ? this.uid : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        return data;
    }

    clone(): LookupTypeDTO {
        const json = this.toJSON();
        let result = new LookupTypeDTO();
        result.init(json);
        return result;
    }
}

export interface ILookupTypeDTO {
    id?: number;
    uid?: string | null;
    name?: string | null;
    description?: string | null;
    sortOrder?: number;
}

export class CountryLookupDTO extends LookupTypeDTO implements ICountryLookupDTO {
    code?: string | null;

    constructor(data?: ICountryLookupDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
        }
    }

    static fromJS(data: any): CountryLookupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CountryLookupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): CountryLookupDTO {
        const json = this.toJSON();
        let result = new CountryLookupDTO();
        result.init(json);
        return result;
    }
}

export interface ICountryLookupDTO extends ILookupTypeDTO {
    code?: string | null;
}

export class DocumentTypeDTO extends LookupTypeDTO implements IDocumentTypeDTO {
    portalType?: PortalTypes;

    constructor(data?: IDocumentTypeDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.portalType = _data["portalType"] !== undefined ? _data["portalType"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portalType"] = this.portalType !== undefined ? this.portalType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DocumentTypeDTO {
        const json = this.toJSON();
        let result = new DocumentTypeDTO();
        result.init(json);
        return result;
    }
}

export interface IDocumentTypeDTO extends ILookupTypeDTO {
    portalType?: PortalTypes;
}

export enum PortalTypes {
    Unknown = 0,
    Consumer = 1,
    Dealer = 2,
}

export class StateLookupDTO extends LookupTypeDTO implements IStateLookupDTO {
    code?: string | null;
    countryId?: number;

    constructor(data?: IStateLookupDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
        }
    }

    static fromJS(data: any): StateLookupDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StateLookupDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): StateLookupDTO {
        const json = this.toJSON();
        let result = new StateLookupDTO();
        result.init(json);
        return result;
    }
}

export interface IStateLookupDTO extends ILookupTypeDTO {
    code?: string | null;
    countryId?: number;
}

export class SettingDTO implements ISettingDTO {
    googleMapsApiKey?: string | null;
    allowedFileUploadExtensions?: string | null;
    maxFileUploadSizeInMegaBytes?: number;
    maxAdditionalConsumerUsers?: number;
    fullAccessCountryCodes?: string | null;
    companyAddress?: string | null;
    mondayThruThursdaySupportHours?: string | null;
    fridaySupportHours?: string | null;

    constructor(data?: ISettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.googleMapsApiKey = _data["googleMapsApiKey"] !== undefined ? _data["googleMapsApiKey"] : <any>null;
            this.allowedFileUploadExtensions = _data["allowedFileUploadExtensions"] !== undefined ? _data["allowedFileUploadExtensions"] : <any>null;
            this.maxFileUploadSizeInMegaBytes = _data["maxFileUploadSizeInMegaBytes"] !== undefined ? _data["maxFileUploadSizeInMegaBytes"] : <any>null;
            this.maxAdditionalConsumerUsers = _data["maxAdditionalConsumerUsers"] !== undefined ? _data["maxAdditionalConsumerUsers"] : <any>null;
            this.fullAccessCountryCodes = _data["fullAccessCountryCodes"] !== undefined ? _data["fullAccessCountryCodes"] : <any>null;
            this.companyAddress = _data["companyAddress"] !== undefined ? _data["companyAddress"] : <any>null;
            this.mondayThruThursdaySupportHours = _data["mondayThruThursdaySupportHours"] !== undefined ? _data["mondayThruThursdaySupportHours"] : <any>null;
            this.fridaySupportHours = _data["fridaySupportHours"] !== undefined ? _data["fridaySupportHours"] : <any>null;
        }
    }

    static fromJS(data: any): SettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["googleMapsApiKey"] = this.googleMapsApiKey !== undefined ? this.googleMapsApiKey : <any>null;
        data["allowedFileUploadExtensions"] = this.allowedFileUploadExtensions !== undefined ? this.allowedFileUploadExtensions : <any>null;
        data["maxFileUploadSizeInMegaBytes"] = this.maxFileUploadSizeInMegaBytes !== undefined ? this.maxFileUploadSizeInMegaBytes : <any>null;
        data["maxAdditionalConsumerUsers"] = this.maxAdditionalConsumerUsers !== undefined ? this.maxAdditionalConsumerUsers : <any>null;
        data["fullAccessCountryCodes"] = this.fullAccessCountryCodes !== undefined ? this.fullAccessCountryCodes : <any>null;
        data["companyAddress"] = this.companyAddress !== undefined ? this.companyAddress : <any>null;
        data["mondayThruThursdaySupportHours"] = this.mondayThruThursdaySupportHours !== undefined ? this.mondayThruThursdaySupportHours : <any>null;
        data["fridaySupportHours"] = this.fridaySupportHours !== undefined ? this.fridaySupportHours : <any>null;
        return data;
    }

    clone(): SettingDTO {
        const json = this.toJSON();
        let result = new SettingDTO();
        result.init(json);
        return result;
    }
}

export interface ISettingDTO {
    googleMapsApiKey?: string | null;
    allowedFileUploadExtensions?: string | null;
    maxFileUploadSizeInMegaBytes?: number;
    maxAdditionalConsumerUsers?: number;
    fullAccessCountryCodes?: string | null;
    companyAddress?: string | null;
    mondayThruThursdaySupportHours?: string | null;
    fridaySupportHours?: string | null;
}

export class DealerSettingDTO implements IDealerSettingDTO {
    allowedFileUploadExtensions?: string | null;
    maxFileUploadSizeInMegaBytes?: number;
    dealerStoreURL?: string | null;
    hrvRegistrationsEmail?: string | null;
    dcrvRegistrationsEmail?: string | null;

    constructor(data?: IDealerSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowedFileUploadExtensions = _data["allowedFileUploadExtensions"] !== undefined ? _data["allowedFileUploadExtensions"] : <any>null;
            this.maxFileUploadSizeInMegaBytes = _data["maxFileUploadSizeInMegaBytes"] !== undefined ? _data["maxFileUploadSizeInMegaBytes"] : <any>null;
            this.dealerStoreURL = _data["dealerStoreURL"] !== undefined ? _data["dealerStoreURL"] : <any>null;
            this.hrvRegistrationsEmail = _data["hrvRegistrationsEmail"] !== undefined ? _data["hrvRegistrationsEmail"] : <any>null;
            this.dcrvRegistrationsEmail = _data["dcrvRegistrationsEmail"] !== undefined ? _data["dcrvRegistrationsEmail"] : <any>null;
        }
    }

    static fromJS(data: any): DealerSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DealerSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowedFileUploadExtensions"] = this.allowedFileUploadExtensions !== undefined ? this.allowedFileUploadExtensions : <any>null;
        data["maxFileUploadSizeInMegaBytes"] = this.maxFileUploadSizeInMegaBytes !== undefined ? this.maxFileUploadSizeInMegaBytes : <any>null;
        data["dealerStoreURL"] = this.dealerStoreURL !== undefined ? this.dealerStoreURL : <any>null;
        data["hrvRegistrationsEmail"] = this.hrvRegistrationsEmail !== undefined ? this.hrvRegistrationsEmail : <any>null;
        data["dcrvRegistrationsEmail"] = this.dcrvRegistrationsEmail !== undefined ? this.dcrvRegistrationsEmail : <any>null;
        return data;
    }

    clone(): DealerSettingDTO {
        const json = this.toJSON();
        let result = new DealerSettingDTO();
        result.init(json);
        return result;
    }
}

export interface IDealerSettingDTO {
    allowedFileUploadExtensions?: string | null;
    maxFileUploadSizeInMegaBytes?: number;
    dealerStoreURL?: string | null;
    hrvRegistrationsEmail?: string | null;
    dcrvRegistrationsEmail?: string | null;
}

export class TermsAndConditionDTO implements ITermsAndConditionDTO {
    id?: number;
    uid?: string;
    version?: string | null;
    name?: string | null;
    content?: string | null;
    isActiveVersion?: boolean;
    isHtml?: boolean;
    companyType?: CompanyTypes;

    constructor(data?: ITermsAndConditionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.uid = _data["uid"] !== undefined ? _data["uid"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.isActiveVersion = _data["isActiveVersion"] !== undefined ? _data["isActiveVersion"] : <any>null;
            this.isHtml = _data["isHtml"] !== undefined ? _data["isHtml"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
        }
    }

    static fromJS(data: any): TermsAndConditionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TermsAndConditionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["uid"] = this.uid !== undefined ? this.uid : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["isActiveVersion"] = this.isActiveVersion !== undefined ? this.isActiveVersion : <any>null;
        data["isHtml"] = this.isHtml !== undefined ? this.isHtml : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        return data;
    }

    clone(): TermsAndConditionDTO {
        const json = this.toJSON();
        let result = new TermsAndConditionDTO();
        result.init(json);
        return result;
    }
}

export interface ITermsAndConditionDTO {
    id?: number;
    uid?: string;
    version?: string | null;
    name?: string | null;
    content?: string | null;
    isActiveVersion?: boolean;
    isHtml?: boolean;
    companyType?: CompanyTypes;
}

export class PostalCodeInfoDTO implements IPostalCodeInfoDTO {
    city?: string | null;
    country?: string | null;
    state?: string | null;
    postalCode?: string | null;

    constructor(data?: IPostalCodeInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : <any>null;
        }
    }

    static fromJS(data: any): PostalCodeInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PostalCodeInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        return data;
    }

    clone(): PostalCodeInfoDTO {
        const json = this.toJSON();
        let result = new PostalCodeInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IPostalCodeInfoDTO {
    city?: string | null;
    country?: string | null;
    state?: string | null;
    postalCode?: string | null;
}

export class DynamicsCountryDTO implements IDynamicsCountryDTO {
    id?: string | null;
    isoCode?: string | null;
    name?: string | null;

    constructor(data?: IDynamicsCountryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.isoCode = _data["isoCode"] !== undefined ? _data["isoCode"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): DynamicsCountryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicsCountryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["isoCode"] = this.isoCode !== undefined ? this.isoCode : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): DynamicsCountryDTO {
        const json = this.toJSON();
        let result = new DynamicsCountryDTO();
        result.init(json);
        return result;
    }
}

export interface IDynamicsCountryDTO {
    id?: string | null;
    isoCode?: string | null;
    name?: string | null;
}

export class ClaimStatusTypeDTO extends LookupTypeDTO implements IClaimStatusTypeDTO {

    constructor(data?: IClaimStatusTypeDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ClaimStatusTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimStatusTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ClaimStatusTypeDTO {
        const json = this.toJSON();
        let result = new ClaimStatusTypeDTO();
        result.init(json);
        return result;
    }
}

export interface IClaimStatusTypeDTO extends ILookupTypeDTO {
}

export class WarrantyClassCodeDTO implements IWarrantyClassCodeDTO {
    description?: string | null;
    parentCode?: string | null;
    classCode?: string | null;
    remedyCodes?: WarrantyRemedyCodeDTO[] | null;

    constructor(data?: IWarrantyClassCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.parentCode = _data["parentCode"] !== undefined ? _data["parentCode"] : <any>null;
            this.classCode = _data["classCode"] !== undefined ? _data["classCode"] : <any>null;
            if (Array.isArray(_data["remedyCodes"])) {
                this.remedyCodes = [] as any;
                for (let item of _data["remedyCodes"])
                    this.remedyCodes!.push(WarrantyRemedyCodeDTO.fromJS(item));
            }
            else {
                this.remedyCodes = <any>null;
            }
        }
    }

    static fromJS(data: any): WarrantyClassCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarrantyClassCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["parentCode"] = this.parentCode !== undefined ? this.parentCode : <any>null;
        data["classCode"] = this.classCode !== undefined ? this.classCode : <any>null;
        if (Array.isArray(this.remedyCodes)) {
            data["remedyCodes"] = [];
            for (let item of this.remedyCodes)
                data["remedyCodes"].push(item.toJSON());
        }
        return data;
    }

    clone(): WarrantyClassCodeDTO {
        const json = this.toJSON();
        let result = new WarrantyClassCodeDTO();
        result.init(json);
        return result;
    }
}

export interface IWarrantyClassCodeDTO {
    description?: string | null;
    parentCode?: string | null;
    classCode?: string | null;
    remedyCodes?: WarrantyRemedyCodeDTO[] | null;
}

export class WarrantyRemedyCodeDTO implements IWarrantyRemedyCodeDTO {
    description?: string | null;
    hours?: number;
    partReturn?: boolean;
    photoRequired?: boolean;
    preAuthorization?: boolean;
    remedyCode?: string | null;

    constructor(data?: IWarrantyRemedyCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.hours = _data["hours"] !== undefined ? _data["hours"] : <any>null;
            this.partReturn = _data["partReturn"] !== undefined ? _data["partReturn"] : <any>null;
            this.photoRequired = _data["photoRequired"] !== undefined ? _data["photoRequired"] : <any>null;
            this.preAuthorization = _data["preAuthorization"] !== undefined ? _data["preAuthorization"] : <any>null;
            this.remedyCode = _data["remedyCode"] !== undefined ? _data["remedyCode"] : <any>null;
        }
    }

    static fromJS(data: any): WarrantyRemedyCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarrantyRemedyCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["hours"] = this.hours !== undefined ? this.hours : <any>null;
        data["partReturn"] = this.partReturn !== undefined ? this.partReturn : <any>null;
        data["photoRequired"] = this.photoRequired !== undefined ? this.photoRequired : <any>null;
        data["preAuthorization"] = this.preAuthorization !== undefined ? this.preAuthorization : <any>null;
        data["remedyCode"] = this.remedyCode !== undefined ? this.remedyCode : <any>null;
        return data;
    }

    clone(): WarrantyRemedyCodeDTO {
        const json = this.toJSON();
        let result = new WarrantyRemedyCodeDTO();
        result.init(json);
        return result;
    }
}

export interface IWarrantyRemedyCodeDTO {
    description?: string | null;
    hours?: number;
    partReturn?: boolean;
    photoRequired?: boolean;
    preAuthorization?: boolean;
    remedyCode?: string | null;
}

export class WarrantyFailureCodeDTO implements IWarrantyFailureCodeDTO {
    description?: string | null;
    failureCode?: string | null;

    constructor(data?: IWarrantyFailureCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.failureCode = _data["failureCode"] !== undefined ? _data["failureCode"] : <any>null;
        }
    }

    static fromJS(data: any): WarrantyFailureCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarrantyFailureCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["failureCode"] = this.failureCode !== undefined ? this.failureCode : <any>null;
        return data;
    }

    clone(): WarrantyFailureCodeDTO {
        const json = this.toJSON();
        let result = new WarrantyFailureCodeDTO();
        result.init(json);
        return result;
    }
}

export interface IWarrantyFailureCodeDTO {
    description?: string | null;
    failureCode?: string | null;
}

export class WarrantyMiscChargeCodeDTO implements IWarrantyMiscChargeCodeDTO {
    description?: string | null;
    limitAmount?: number;
    miscChargeCode?: string | null;

    constructor(data?: IWarrantyMiscChargeCodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.limitAmount = _data["limitAmount"] !== undefined ? _data["limitAmount"] : <any>null;
            this.miscChargeCode = _data["miscChargeCode"] !== undefined ? _data["miscChargeCode"] : <any>null;
        }
    }

    static fromJS(data: any): WarrantyMiscChargeCodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarrantyMiscChargeCodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["limitAmount"] = this.limitAmount !== undefined ? this.limitAmount : <any>null;
        data["miscChargeCode"] = this.miscChargeCode !== undefined ? this.miscChargeCode : <any>null;
        return data;
    }

    clone(): WarrantyMiscChargeCodeDTO {
        const json = this.toJSON();
        let result = new WarrantyMiscChargeCodeDTO();
        result.init(json);
        return result;
    }
}

export interface IWarrantyMiscChargeCodeDTO {
    description?: string | null;
    limitAmount?: number;
    miscChargeCode?: string | null;
}

export class ExportDTO implements IExportDTO {
    contentType?: string | null;
    base64?: string | null;
    fileName?: string | null;

    constructor(data?: IExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
            this.base64 = _data["base64"] !== undefined ? _data["base64"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
        }
    }

    static fromJS(data: any): ExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        data["base64"] = this.base64 !== undefined ? this.base64 : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        return data;
    }

    clone(): ExportDTO {
        const json = this.toJSON();
        let result = new ExportDTO();
        result.init(json);
        return result;
    }
}

export interface IExportDTO {
    contentType?: string | null;
    base64?: string | null;
    fileName?: string | null;
}

export class NotificationRegistrationDTO extends ValidationBaseDTO implements INotificationRegistrationDTO {
    userId?: string;
    pushToken?: string | null;
    firebaseToken?: string | null;
    devicePlatformType?: DevicePlatformTypes;
    companyType?: CompanyTypes;

    constructor(data?: INotificationRegistrationDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.pushToken = _data["pushToken"] !== undefined ? _data["pushToken"] : <any>null;
            this.firebaseToken = _data["firebaseToken"] !== undefined ? _data["firebaseToken"] : <any>null;
            this.devicePlatformType = _data["devicePlatformType"] !== undefined ? _data["devicePlatformType"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
        }
    }

    static fromJS(data: any): NotificationRegistrationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationRegistrationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["pushToken"] = this.pushToken !== undefined ? this.pushToken : <any>null;
        data["firebaseToken"] = this.firebaseToken !== undefined ? this.firebaseToken : <any>null;
        data["devicePlatformType"] = this.devicePlatformType !== undefined ? this.devicePlatformType : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): NotificationRegistrationDTO {
        const json = this.toJSON();
        let result = new NotificationRegistrationDTO();
        result.init(json);
        return result;
    }
}

export interface INotificationRegistrationDTO extends IValidationBaseDTO {
    userId?: string;
    pushToken?: string | null;
    firebaseToken?: string | null;
    devicePlatformType?: DevicePlatformTypes;
    companyType?: CompanyTypes;
}

export enum DevicePlatformTypes {
    Unknown = 0,
    Android = 1,
    Ios = 2,
    Web = 3,
}

export class NotificationDTO extends ValidationBaseDTO implements INotificationDTO {
    title!: string;
    body!: string;
    companyType!: CompanyTypes;
    notificationType!: NotificationTypes;
    vehicleId?: number | null;
    viNs?: string[] | null;
    brandIds?: string[] | null;

    constructor(data?: INotificationDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.body = _data["body"] !== undefined ? _data["body"] : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
            this.notificationType = _data["notificationType"] !== undefined ? _data["notificationType"] : <any>null;
            this.vehicleId = _data["vehicleId"] !== undefined ? _data["vehicleId"] : <any>null;
            if (Array.isArray(_data["viNs"])) {
                this.viNs = [] as any;
                for (let item of _data["viNs"])
                    this.viNs!.push(item);
            }
            else {
                this.viNs = <any>null;
            }
            if (Array.isArray(_data["brandIds"])) {
                this.brandIds = [] as any;
                for (let item of _data["brandIds"])
                    this.brandIds!.push(item);
            }
            else {
                this.brandIds = <any>null;
            }
        }
    }

    static fromJS(data: any): NotificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["body"] = this.body !== undefined ? this.body : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        data["notificationType"] = this.notificationType !== undefined ? this.notificationType : <any>null;
        data["vehicleId"] = this.vehicleId !== undefined ? this.vehicleId : <any>null;
        if (Array.isArray(this.viNs)) {
            data["viNs"] = [];
            for (let item of this.viNs)
                data["viNs"].push(item);
        }
        if (Array.isArray(this.brandIds)) {
            data["brandIds"] = [];
            for (let item of this.brandIds)
                data["brandIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): NotificationDTO {
        const json = this.toJSON();
        let result = new NotificationDTO();
        result.init(json);
        return result;
    }
}

export interface INotificationDTO extends IValidationBaseDTO {
    title: string;
    body: string;
    companyType: CompanyTypes;
    notificationType: NotificationTypes;
    vehicleId?: number | null;
    viNs?: string[] | null;
    brandIds?: string[] | null;
}

export enum NotificationTypes {
    Unknown = 0,
    MaintenanceThreeMonth = 1,
    MaintenanceSixMonth = 2,
    Recall = 3,
    TechnicalServiceBulletin = 4,
    InformationalVideo = 5,
    NewsMaterial = 6,
    Custom = 7,
    VehicleRegistrationStatus = 8,
}

export class UserNotificationDTO extends ValidationBaseDTO implements IUserNotificationDTO {
    userNotificationUid?: string;
    notificationType?: NotificationTypes;
    title?: string | null;
    content?: string | null;
    isRead?: boolean;
    sentDateTime?: moment.Moment;
    companyType?: CompanyTypes;

    constructor(data?: IUserNotificationDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userNotificationUid = _data["userNotificationUid"] !== undefined ? _data["userNotificationUid"] : <any>null;
            this.notificationType = _data["notificationType"] !== undefined ? _data["notificationType"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.isRead = _data["isRead"] !== undefined ? _data["isRead"] : <any>null;
            this.sentDateTime = _data["sentDateTime"] ? moment(_data["sentDateTime"].toString()) : <any>null;
            this.companyType = _data["companyType"] !== undefined ? _data["companyType"] : <any>null;
        }
    }

    static fromJS(data: any): UserNotificationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNotificationUid"] = this.userNotificationUid !== undefined ? this.userNotificationUid : <any>null;
        data["notificationType"] = this.notificationType !== undefined ? this.notificationType : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["isRead"] = this.isRead !== undefined ? this.isRead : <any>null;
        data["sentDateTime"] = this.sentDateTime ? this.sentDateTime.toISOString() : <any>null;
        data["companyType"] = this.companyType !== undefined ? this.companyType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): UserNotificationDTO {
        const json = this.toJSON();
        let result = new UserNotificationDTO();
        result.init(json);
        return result;
    }
}

export interface IUserNotificationDTO extends IValidationBaseDTO {
    userNotificationUid?: string;
    notificationType?: NotificationTypes;
    title?: string | null;
    content?: string | null;
    isRead?: boolean;
    sentDateTime?: moment.Moment;
    companyType?: CompanyTypes;
}

export class ApiResultDTO extends ValidationBaseDTO implements IApiResultDTO {

    constructor(data?: IApiResultDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApiResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ApiResultDTO {
        const json = this.toJSON();
        let result = new ApiResultDTO();
        result.init(json);
        return result;
    }
}

export interface IApiResultDTO extends IValidationBaseDTO {
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

/* eslint-disable @typescript-eslint/ban-ts-comment */
/**
 * Configuration class needed in base class.
 * The config is provided to the API client at initialization time.
 * API clients inherit from #AuthorizedApiBase and provide the config.
 */
// @ts-nocheck
/* eslint-disable */

export interface Config {
  transformHeaders: (options: AxiosRequestConfig) => AxiosRequestConfig;
  transformResult(
    url: string,
    response: AxiosResponse,
    processor: (response: AxiosResponse) => Promise<any>
  ): Promise<any>;
}